import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { ButtonS } from "../../styles/Common";
import icoCaution from "../../styles/images/ico_caution.svg";
import { ReactComponent as IcoCaution } from "../../styles/images/ico_caution_not.svg";
import { amoActions } from "../../store/slices/amoSlice";
import { authActions } from "../../store/slices/authSlice";
import { mainActions } from "../../store/slices/mainSlice";
import { pointActions } from "../../store/slices/pointSlice";
import { serviceActions } from "../../store/slices/serviceSlice";
import { userActions } from "../../store/slices/userSlice";
import { useDispatch } from "react-redux";

const massageReset = (dispatch) => {
  dispatch(
    amoActions.showMsg({
      msg: ``,
      type: "",
    })
  );
  dispatch(
    authActions.showMsg({
      msg: ``,
      type: "",
    })
  );
  dispatch(
    mainActions.showMsg({
      msg: ``,
      type: "",
    })
  );
  dispatch(
    pointActions.showMsg({
      msg: ``,
      type: "",
    })
  );
  dispatch(
    serviceActions.showMsg({
      msg: ``,
      type: "",
    })
  );
  dispatch(
    userActions.showMsg({
      msg: ``,
      type: "",
    })
  );
};

// Modal 1
// When the confirmation button is clicked, execute the function and then close the modal
export const Modal = (props) => {
  const dispatch = useDispatch();
  const { title, setOpenModal, callbackFunc } = props;
  const [modalopacity, setModalOpacity] = useState(0);
  useEffect(() => {
    setModalOpacity(1);
  }, [setModalOpacity]);

  return (
    <ModalWrapper>
      <ModalContainer modalopacity={modalopacity}>
        <ModalBody>
          <ModalHeader>{title}</ModalHeader>
          <ModalMsg>{props.children}</ModalMsg>
          <ModalBtns>
            <ButtonS
              col="purple_dark"
              onClick={
                callbackFunc
                  ? () => {
                      callbackFunc();
                      setOpenModal(false);
                      massageReset(dispatch);
                    }
                  : () => {
                      setOpenModal(false);
                      massageReset(dispatch);
                    }
              }
            >
              확인
            </ButtonS>
          </ModalBtns>
        </ModalBody>
      </ModalContainer>
    </ModalWrapper>
  );
};

// Modal 2
// When the confirmation button is clicked, execute the function
// When the cancel button is clicked, close the modal
export const FuncModal = (props) => {
  const dispatch = useDispatch();
  const {
    title,
    setOpenModal,
    callbackFunc,
    cancelText,
    confirmText,
    cancelFunc,
  } = props;
  const [modalopacity, setModalOpacity] = useState(0);
  useEffect(() => {
    setModalOpacity(1);
  }, [setModalOpacity]);

  return (
    <ModalWrapper>
      <ModalContainer modalopacity={modalopacity}>
        <ModalBody>
          <ModalHeader>{title}</ModalHeader>
          <ModalMsg>{props.children}</ModalMsg>
          <ModalBtns>
            <ButtonS
              col="purple_dark"
              onClick={() => {
                cancelFunc();
                setOpenModal(false);
                massageReset(dispatch);
              }}
            >
              {cancelText ? cancelText : "취소"}
            </ButtonS>
            <ButtonS
              col="pink"
              onClick={() => {
                callbackFunc();
                setOpenModal(false);
                massageReset(dispatch);
              }}
            >
              {confirmText ? confirmText : "확인"}
            </ButtonS>
          </ModalBtns>
        </ModalBody>
      </ModalContainer>
    </ModalWrapper>
  );
};

// Modal 3 (ex: 인증번호가 일지하지 않습니다) 등의 falsy한 모달
export const ReturnModal = (props) => {
  const { title, setOpenModal, callbackFunc } = props;
  const dispatch = useDispatch();
  const [modalopacity, setModalOpacity] = useState(0);
  useEffect(() => {
    setModalOpacity(1);
  }, [setModalOpacity]);

  return (
    <ModalWrapper>
      <ModalContainer modalopacity={modalopacity}>
        <ModalBody>
          <ReturnModalHeader>
            <IcoCaution />
            <h3>{title}</h3>
          </ReturnModalHeader>
          <ReturnModalMsg>{props.children}</ReturnModalMsg>
          <ReturnModalBtns>
            <ButtonS
              col="purple_dark"
              onClick={
                callbackFunc
                  ? () => {
                      callbackFunc();
                      setOpenModal(false);
                      massageReset(dispatch);
                    }
                  : () => {
                      setOpenModal(false);
                      massageReset(dispatch);
                    }
              }
            >
              확인
            </ButtonS>
          </ReturnModalBtns>
        </ModalBody>
      </ModalContainer>
    </ModalWrapper>
  );
};

// Modal 4 (ex: 인증번호가 일지하지 않습니다) 등의 falsy한 모달, 안내가 길때
export const ReturnContentModal = (props) => {
  const { title, setOpenModal, callbackFunc } = props;
  const dispatch = useDispatch();
  const [modalopacity, setModalOpacity] = useState(0);
  useEffect(() => {
    setModalOpacity(1);
  }, [setModalOpacity]);

  return (
    <ModalWrapper>
      <ModalContainer modalopacity={modalopacity}>
        <ModalBody>
          <ReturnModalHeader>
            <h3>{title}</h3>
          </ReturnModalHeader>
          <ReturnContentModalMsg>
            <IcoCaution />
            {props.children}
          </ReturnContentModalMsg>
          <ReturnModalBtns>
            <ButtonS
              col="purple_dark"
              onClick={
                callbackFunc
                  ? () => {
                      callbackFunc();
                      setOpenModal(false);
                      massageReset(dispatch);
                    }
                  : () => {
                      setOpenModal(false);
                      massageReset(dispatch);
                    }
              }
            >
              확인
            </ButtonS>
          </ReturnModalBtns>
        </ModalBody>
      </ModalContainer>
    </ModalWrapper>
  );
};

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(37, 21, 98, 0.33);
  z-index: 9999999;
`;

const ModalContainer = styled.div`
  position: absolute;
  width: 90%;
  min-width: 20rem;
  /* min-height: 200px; */
  height: fit-content;
  margin: auto;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: ${({ theme }) => theme.color.white};
  border-radius: 1rem;
  opacity: ${({ modalopacity }) => modalopacity};
  transition: opacity 0.3s; /* Apply transition effect */
`;

const ModalBody = styled.div`
  padding: 3rem 2rem 1.8rem 2rem;
`;

const ModalHeader = styled.div`
  text-align: center;
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2rem; /* 111.111% */
`;

const ModalBtns = styled.div`
  margin-top: 3rem;
  text-align: center;
  button {
    margin: 0 1rem;
  }
`;

const ModalMsg = styled.div`
  text-align: center;
  margin-top: 2rem;
`;

const ReturnModalHeader = styled(ModalHeader)`
  display: flex;
  align-items: center;

  h3 {
    font-size: 1.8rem;
    font-style: normal;
    font-weight: 700;
  }
  svg {
    /* border: 1px solid #ccc; */
    margin-right: 1rem;
    background: transparent;
    /* box-shadow: 0px 16px 16px 0px rgba(0, 0, 0, 0.1); */
  }
`;
const ReturnModalBtns = styled(ModalBtns)`
  margin-top: 2rem;
`;
const ReturnModalMsg = styled(ModalMsg)`
  margin-top: 0;
`;
const ReturnContentModalMsg = styled(ReturnModalMsg)`
  display: flex;
  text-align: left;
  p {
    margin-left: 1em;
    width: calc(100% - 4.7rem);
    font-size: 1.6rem;
    line-height: 2rem; /* 125% */
  }
`;
